// The card about to be saved, read before any money moves (Robin, 26 Oct
// 2026: a referral code paid with one of the referrer's own cards is
// refused at the pay press, never after paying). Imports nothing, so node
// --test can run it (card-token.test.mjs).
//
// stripe.createConfirmationToken turns what the Payment Element (or the
// Express Checkout sheet) holds into a ConfirmationToken: nothing is saved or
// charged by it. The server reads the card's fingerprint from it
// (Api::V2::OrdersController#pay_press_card), and the SetupIntent is then
// confirmed with the same token. Any failure gives null and the confirm goes
// on as before, from the elements; the referrer's reward is then held for a
// person if it was their card (Referral::RewardHold).
export const confirmationTokenFor = async (stripe, elements, { kind, payerEmail } = {}) => {
  if (!stripe || typeof stripe.createConfirmationToken !== 'function') return null
  try {
    const params = kind === 'card' && payerEmail ? { payment_method_data: { billing_details: { email: payerEmail } } } : undefined
    const { confirmationToken, error } = await stripe.createConfirmationToken(params ? { elements, params } : { elements })
    if (error || !confirmationToken?.id) return null
    return confirmationToken.id
  } catch (e) {
    return null
  }
}

// stripe.confirmSetup's arguments: with a token, the token carries the card
// (and the email typed beside it); without one, the elements do, as before.
export const confirmSetupArgs = ({ elements, clientSecret, origin, kind, payerEmail, tokenId }) => {
  const confirmParams = { return_url: `${origin}/checkout/success/embedded` }
  if (tokenId) {
    confirmParams.confirmation_token = tokenId
    return { clientSecret, confirmParams, redirect: 'if_required' }
  }
  if (kind === 'card' && payerEmail) confirmParams.payment_method_data = { billing_details: { email: payerEmail } }
  return { elements, clientSecret, confirmParams, redirect: 'if_required' }
}
